module.exports = __webpack_public_path__ + "static/media/iphone2.10245fd7.png";